































import {
    Component,
    Emit,
    Prop,
    Vue,
    Watch,
    Mixins,
} from 'vue-property-decorator';
import { ShoppingCart } from '@/entities/ShoppingCart';
import BaseMixin from '@/mixins/BaseMixin';

@Component({})
export default class ShoppingCartOverviewMetadata extends Mixins(BaseMixin) {
    @Prop(Boolean)
    private isUserAuthenticated!: boolean;

    @Prop(Boolean)
    private isEmpty!: boolean;

    @Prop(String)
    private cartName!: string;

    @Prop(String)
    private orderName!: string;

    private currentCartName: string = this.cartName;
    private currentOrderName: string = this.orderName;

    public get showSaveButton(): boolean {
        return (
            this.isCartNameValid &&
            (this.cartName !== this.currentCartName ||
                this.orderName !== this.currentOrderName)
        );
    }

    public get isCartNameValid(): boolean {
        return this.currentCartName !== '';
    }

    @Emit('save-metadata')
    private saveMetadata(): { cartName: string; orderName: string } {
        return {
            cartName: this.currentCartName,
            orderName: this.currentOrderName,
        };
    }

    @Watch('cartName')
    private cartNameChanged(cartName: string): void {
        this.currentCartName = cartName;
    }

    @Watch('orderName')
    private orderNameChanged(orderName: string): void {
        this.currentOrderName = orderName;
    }
}
